//HackingReview.jsx

import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { 
  FaStar, 
  FaStarHalfAlt, 
  FaRegStar, 
  FaQuoteLeft 
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ENDPOINT from '../../data/ENDPOINT';
import SecurityHeaders from '../../data/SecurityHeaders';

// --- DATA ---
// const testimonials = [
//   {
//     name: 'Manidhar',
//     title: 'Cybersecurity Analyst',
//     imageUrl: 'https://skillsuprise.com/data/cyberPDF/placements/manindhar.png',
//     quote: "Casually attended a webinar & became a Cybersecurity Analyst. Unexpected but amazing!",
//     dark: true, 
//   },
//   {
//     name: 'Amulya Sree P.',
//     title: 'SOC Engineer @ Hatsuchi Group',
//     imageUrl: 'https://skillsuprise.com/data/cyberPDF/placements/amulya.png',
//     quote: "The placement support was incredible. Landed my dream job as a SOC Engineer with a 6.5 LPA package!",
//     dark: false,
//   },
//   {
//     name: 'Sowmya Chaganti',
//     title: 'Software Developer',
//     imageUrl: 'https://skillsuprise.com/data/images/sowmyachaganti.jpg',
//     quote: "Attending their workshops was a game-changer for my career. The insights were truly invaluable!",
//     dark: false,
//   },
// ];

// --- COLOR PALETTE ---
const colors = {
  brandBlue: '#2a63b0',
  accentBlue: '#4a90e2',
  lightBg: '#F8F9FA', 
  textPrimary: '#212529', 
  textSecondary: '#6C757D', 
  starColor: '#FFC107', 
  cardBg: '#FFFFFF',
  cardBgDark: '#2C3E50', 
  cardTextDark: '#ECF0F1',
};


/**
 * StarRating Component
 */
const StarRating = ({ rating, size = 28 }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    if (i <= Math.floor(rating)) {
      stars.push(<FaStar key={i} size={size} color={colors.starColor} />);
    } else if (i === Math.ceil(rating) && !Number.isInteger(rating)) {
      stars.push(<FaStarHalfAlt key={i} size={size} color={colors.starColor} />);
    } else {
      stars.push(<FaRegStar key={i} size={size} color={colors.starColor} />);
    }
  }
  return <div className="d-flex justify-content-center gap-2 mb-3">{stars}</div>;
};

/**
 * TestimonialCard Component
 */
const TestimonialCard = ({ name, title, imageUrl, quote, dark = false, expanded, onToggle }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const cardStyles = {
    backgroundColor: dark ? colors.cardBgDark : colors.cardBg,
    color: dark ? colors.cardTextDark : colors.textPrimary,
    borderRadius: '16px', 
    border: 'none',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  };

  const quoteStyles = {
    fontSize: '1.1rem',
    lineHeight: '1.6',
    fontStyle: 'italic',
    color: dark ? colors.cardTextDark : colors.textPrimary,
  };

  return (
    <div className="col-12 col-md-6 col-lg-4 d-flex">
      <div
        className="card h-100 shadow-lg w-100"
        style={cardStyles}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-10px)';
          e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.1)';
        }}
      >
        <div className="card-body p-4 d-flex flex-column">
          <FaQuoteLeft 
            size={30} 
            className="mb-3" 
            style={{ color: dark ? colors.accentBlue : colors.accentBlue + '40' }} 
          />
          
          <p
  className="flex-grow-1"
  style={{
    ...quoteStyles,
    display: "-webkit-box",
    WebkitLineClamp: expanded ? "unset" : 4,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  }}
>
  "{quote}"
</p>

{quote.length > 120 && (
  <span
  onClick={onToggle}
    style={{
      color: "#4a90e2",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "500",
    }}
  >
    {expanded ? "Show Less" : "Read More"}
  </span>
)}
          
          <div className="d-flex align-items-center mt-4">
            <img
              src={imageUrl}
              alt={name}
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: `2px solid ${colors.accentBlue}`,
                padding: '2px',
              }}
            />
            <div className="ms-3">
              <h6 className="fw-bold mb-0" style={{ fontSize: '1rem' }}>{name}</h6>
              
              <p className="small mb-0" style={{ color: dark ? colors.cardTextDark + '90' : colors.textSecondary }}>
                {title}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


/**
 * MAIN: HackingReview Component
 */
function HackingReview() {

  const [reviews, setReviews] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const data = new FormData();
        data.append("limit", 3); // limit for UI
  
        const res = await axios.post(
          ENDPOINT + "get-reviews.php",
          data,
          SecurityHeaders
        );
  
        if (res.data.status === "success") {
          setReviews(res.data.data);
        }
      } catch (error) {
        console.log("Error fetching reviews", error);
      }
    };
  
    fetchReviews();
  }, []);


  return (
    <div
      style={{
        backgroundColor: colors.lightBg,
        minHeight: '100vh',
        padding: '80px 0',
        fontFamily: 'Segoe UI, Roboto, "Helvetica Neue", Arial, sans-serif',
        // --- FIX ---
        position: 'relative', // Create a stacking context
        zIndex: 10,           // Lift this section up
        // -----------
      }}
    >
      <div className="container">
        
        {/* --- HEADER --- */}
        <div className="text-center mb-5">
          <h1
            className="display-4 fw-bolder mb-3"
            style={{ color: colors.textPrimary }}
          >
            What Our Students Say ✨
          </h1>
          
          <StarRating rating={4.8} />

          <p className="fs-5 mb-3" style={{ color: colors.textSecondary }}>
            <span className="fw-bold" style={{ color: colors.brandBlue }}>
              (4.8/5)
            </span>{' '}
            Based on Reviews
          </p>
          
          <div
            style={{
              width: '80px',
              height: '4px',
              backgroundColor: colors.brandBlue,
              margin: '0 auto',
              borderRadius: '2px',
            }}
          ></div>
        </div>

        {/* --- REVIEWS GRID --- */}
        <div className="row g-4 g-lg-5 justify-content-center">
        {reviews.length > 0 ? (
  reviews.map((review, index) => (
    <TestimonialCard
    key={index}
    name={review.name}
    title={review.email}
    imageUrl={`https://admin.siliconmindstechnologies.com/${review.profile_pic}`}
    quote={review.review}
    dark={index % 3 === 0}
    expanded={expandedIndex === index}
    onToggle={() =>
      setExpandedIndex(expandedIndex === index ? null : index)
    }
  />
          ))) : (
            <p>Loading...</p>
          )
          }
        </div>

        {/* --- CTA BUTTON --- */}
        <div className="text-center mt-5 pt-3">
          <Link
            to="/reviews" 
            className="btn btn-lg px-5 py-3 fw-bold shadow btn-siloconMinds-orng "
            style={{
              backgroundColor: colors.brandBlue,
              color: '#ffffff',
              borderRadius: '50px', 
              fontSize: '18px',
              letterSpacing: '0.5px',
              transition: 'all 0.3s ease',
              textDecoration: 'none', 
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = colors.accentBlue;
              e.currentTarget.style.transform = 'translateY(-3px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = colors.brandBlue;
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Explore All Reviews
          </Link>
        </div>

      </div>
    </div>
  );
}

export default HackingReview;